<template>
  <v-layout>
    <v-spacer />
    <v-flex
      :class="$vuetify.rtl | rtlTextAlign"
      xs12
      md10
    >
      <span>{{ $t(title) }}:</span>
    </v-flex>
    <v-flex :class="$vuetify.rtl | rtlTextAlign">
      <span>-{{ totalDiscount | money }}</span>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'OrderDiscountTotal',

  props: {
    totalDiscount: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: 'Total Discount'
    }
  }
}
</script>
